import { render, staticRenderFns } from "./PlotProxy.vue?vue&type=template&id=3c5cc457&"
import script from "./PlotProxy.vue?vue&type=script&lang=js&"
export * from "./PlotProxy.vue?vue&type=script&lang=js&"
import style0 from "./PlotProxy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports